import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "../Icons";
import { useIsFetching } from "react-query";

export function UnAuthorized() {
  const navigate = useNavigate();
  const isFetching = useIsFetching();

  return (
    <>
      <div className="vh-100 w-100 d-flex align-items-center justify-content-center text-center">
        {!isFetching ? (
          <div>
            <Logo />
            <h1 className="display-5 mt-2">Admin Only</h1>
            <p className="h5 mb-3">
              Unauthorized, Please contact your administrator for access.
            </p>
            <Button
              onClick={() => navigate(-1)}
              variant=""
              className="text-primary text-underline"
            >
              Go back
            </Button>
          </div>
        ) : null}
      </div>
    </>
  );
}
